import {
  IonButton,
  IonContent,
  IonIcon,
  IonModal,
  IonProgressBar
} from "@ionic/react";
import { timeOutline } from "ionicons/icons";

import { ReactComponent as DashboardIcon } from "../assets/graphics/team_dashboard.svg";
import { ReactComponent as BotIcon } from "../assets/graphics/smart_toy.svg";
import { ReactComponent as LobbiesIcon } from "../assets/graphics/workspaces.svg";
import { ReactComponent as RankIcon } from "../assets/graphics/stars.svg";
import { ReactComponent as HelpIcon } from "../assets/graphics/support.svg";

import dashboardImage from "../assets/graphics/Dashboard_screenshot.png";
import botsImage from "../assets/graphics/Bot_Screenshot.png";
import lobbiesImage from "../assets/graphics/Lobbies_screenshot.png";

import React, { useState } from "react";
import { updateAccount } from "../lib/firebase";
import { useUsersStore } from "../stores/users.store";

const tourPages = [
  {
    title: "Dashboard",
    description:
      "The Dashboard offers a view of your profile, wallet, competitive bots, and the ability to challenge others for the top spot.",
    image: dashboardImage,
    icon: <DashboardIcon />,
    tabTitle: "Dash"
  },
  {
    title: "Bots",
    description:
      "Create strategies using risk-free simulated trading bots. Connect to exchanges with API and go live with your bots.",
    icon: <BotIcon />,
    image: botsImage,
    tabTitle: "My Bots"
  },
  {
    title: "Lobbies",
    description:
      "Compete for QUO prizes and global rankings while learning from fellow traders in a simulated trading environment.",
    image: lobbiesImage,
    icon: <LobbiesIcon />,
    tabTitle: "Lobbies"
  },
  {
    title: "Leaderboard",
    description:
      "Explore the leaderboard showcasing top-performing users and their exceptional trading bots.",
    icon: <RankIcon />,
    tabTitle: "Rank"
  },
  {
    title: "Help Center",
    description:
      "We are here to help! Please read our blogs, FAQs, or send us an email to get in touch with us.",
    icon: <HelpIcon />,
    tabTitle: "Help"
  }
];

const tourImages = tourPages.map(p => p.image);

export const GuidedTour: React.FC<{
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}> = ({ isOpen, setIsOpen }) => {
  const [page, setPage] = useState(0);
  const user = useUsersStore(state => state.user);
  const activePage = tourPages[page - 1];
  const firstPage = page === 0;
  const lastPage = page === tourPages.length;
  const completeTour = () => {
    setIsOpen(false);
    if (user) {
      updateAccount(user.userId, { hasCompletedTour: true });
    }
  };
  return (
    <>
      <IonModal
        isOpen={isOpen}
        onDidDismiss={() => {}}
        className="overlay-image"
      >
        <div className="flex justify-center" style={{ paddingTop: "10vh" }}>
          {!firstPage && tourImages[page - 1] && (
            <img
              src={tourImages[page - 1]}
              alt="Intro"
              className="w-64 h-auto"
            />
          )}
        </div>
      </IonModal>
      <IonModal
        initialBreakpoint={0.5}
        isOpen={isOpen}
        canDismiss={lastPage}
        className="guided-tour"
      >
        <IonContent scrollY={false}>
          <div className="p-4 flex flex-col h-1/2 bg-primary-50 text-white relative">
            {firstPage ? (
              <div className="pt-8">
                <div className="flex items-center">
                  <IonIcon icon={timeOutline} className="text-xl" />
                  <p className="text-sm pl-2 font-semibold">
                    15 Second Guided Tour
                  </p>
                </div>
                <p className="text-4xl font-semibold pt-4 w-5/6 h-36">
                  Getting started with QuidPro
                </p>
              </div>
            ) : (
              <div>
                <div className="flex justify-around bg-primary-100 shadow-2xl px-4 py-4 rounded-t-lg">
                  {tourPages.map((p, index) => {
                    const active = index + 1 === page;
                    return (
                      <div key={index} className="flex flex-col items-center">
                        {React.cloneElement(p.icon, {
                          className: active ? "selected-fill" : ""
                        })}
                        <p
                          className={`text-sm pt-2 ${
                            active ? "text-secondary" : "text-primary"
                          }`}
                        >
                          {p.tabTitle}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <p className="text-2xl font-bold pt-4">{activePage.title}</p>
                <p className="text-text-light h-16">{activePage.description}</p>
              </div>
            )}
            <div className="flex items-center justify-between pt-12">
              <IonProgressBar
                value={page / 5}
                className="w-1/2 guided-tour mr-5"
              />
              <IonButton
                fill={lastPage ? "solid" : "clear"}
                size="small"
                className={`rounded-2xl text-white normal-case font-bold ${
                  lastPage ? "text-base" : "text-lg"
                }`}
                color={lastPage ? "dark" : ""}
                onClick={
                  lastPage ? () => completeTour() : () => setPage(page + 1)
                }
              >
                {firstPage ? "Start" : lastPage ? "Get Started" : "Next"}
              </IonButton>
            </div>
          </div>
        </IonContent>
      </IonModal>
    </>
  );
};
